import { MailIcon, MapPinIcon, PhoneIcon } from "lucide-react";
import ScheduleTable from "../opening-hour-table";

export default function StoreInfo({ storeInfo }: { storeInfo: any }) {
	return (
		<section className="container mx-auto mb-2 space-y-8">
			<div className="grid grid-cols-1 gap-4 md:grid-cols-2">
				<div>
					<h2 className="mb-2 font-bold text-2xl">Kontaktinformasjon</h2>
					<ul className="space-y-2 text-gray-700 text-md">
						<li className="flex items-center gap-2">
							<MapPinIcon className="h-4 w-4" />
							<a
								title="Google Maps"
								href="https://maps.app.goo.gl/uhW6HAYtqZj3QnWu5"
								className="font-medium"
							>
								{" "}
								Slemdalsveien 70, 0370 Oslo
							</a>
						</li>
						<li className="flex items-center gap-2">
							<PhoneIcon className="h-4 w-4" />
							<a
								title="Telefon 23223004"
								href="tel:23223004"
								className="text-blue-600 hover:underline"
							>
								23223004
							</a>
						</li>
						<li className="flex items-center gap-2">
							<MailIcon className="h-4 w-4" />
							<a
								title="E-post post@billies.no"
								href="mailto:post@billies.no"
								className="text-blue-600 hover:underline"
							>
								post@billies.no
							</a>
						</li>
					</ul>
				</div>
				<div>
					<h2 className="mb-2 font-bold text-2xl">Åpningstider</h2>
					<ScheduleTable scheduleData={storeInfo.openingHours} />
				</div>
			</div>
		</section>
	);
}
